import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const sellApi = createAsyncThunk(
  "sell_fintso",
  async ({ name = "", startDate = "", endDate = "" }) => {
    const params = {};

    // Add name to the query if provided
    if (name) {
      params.customerName = name;
    }

    // Add date range to the query if provided
    if (startDate) {
      params.startDate = startDate;
    }
    if (endDate) {
      params.endDate = endDate;
    }

    const response = await axiosInstance.get("/fintso_transactions/sell", {
      params, // Pass the parameters to the API request
    });
    if (response) {
      // console.log("customerName", response.data);
      return response.data;
    }
  }
);

const sellSlice = createSlice({
  name: "sell_fintso",
  initialState: {
    sell: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sellApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(sellApi.fulfilled, (state, action) => {
        state.sell = action.payload;
        state.loading = false;
      })
      .addCase(sellApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default sellSlice.reducer;
